import { Component, OnInit } from '@angular/core';
import { SectionsService } from '../../../_services/sections.service';
import { AppConstants } from '../../../app.constants';

@Component({
	selector: 'app-city-carousel',
	templateUrl: './city-carousel.component.html',
	styleUrls: ['./city-carousel.component.scss']
})
export class CityCarouselComponent implements OnInit {

	public sections;

	

	constructor( private _sectionsService: SectionsService ) {
		let sections = AppConstants.sectionCity;

		let newSectionCarousel = [];
		var j = 0;
		for(var i = 0; i < sections.length; i++){
			if(sections[i].isInCarousel){
				newSectionCarousel.push(sections[i])	
				newSectionCarousel[j]._id = j;
				j++;
			}	
		}
		this.sections = newSectionCarousel;
	}

	ngOnInit() {
		this._sectionsService.setCurrentSectionContent(this.sections);
	}

}
